const TRY_AGAIN = `We couldn't process your payment. Try again.`
const CONTACT_BANK = `We couldn't process your payment. Contact your bank or try another card.`
const INVALID_AMOUNT_MSG = `We couldn't process your payment because the amount entered isn't valid. Check the amount and try again.`
const INSUFFICIENT_FUNDS_MSG = `We couldn't process your payment because there weren't enough funds on the card. Try a different card.`
const VENDOR_ERROR = `We couldn't process your payment. We're working with our vendor and will contact you when the issue is resolved.`
const CHECK_CARD = `We couldn't process your payment. Check the card details and try again.`

export const KNOWN_PAYMENT_ERRORS = [
  {
    name: 'THREE_D_SECURITY_AUTHENTICATION_REQUIRED',
    description: TRY_AGAIN,
  },
  {
    name: 'AUTHORIZATION_AMOUNT_NOT_VALID',
    description: INVALID_AMOUNT_MSG,
  },
  {
    name: 'CALL_ISSUER',
    description: CONTACT_BANK,
  },
  {
    name: 'CVV_ERROR',
    description: CHECK_CARD,
  },
  {
    name: 'DO_NOT_HONOR',
    description: `Your bank declined this payment. Contact your bank or try another card.`,
  },
  {
    name: 'EXPIRED_CARD',
    description: `This card has expired. Try a valid card.`,
  },
  {
    name: 'GENERAL_PAYMENT_PROCESSING_ERROR',
    description: TRY_AGAIN,
  },
  {
    name: 'HIGH_RISK_ERROR',
    description: TRY_AGAIN,
  },
  {
    name: 'INSUFFICIENT_FUNDS',
    description: INSUFFICIENT_FUNDS_MSG,
  },
  {
    name: 'INVALID_AMOUNT',
    description: INVALID_AMOUNT_MSG,
  },
  {
    name: 'INVALID_CARD_NUMBER',
    description: `The card number entered is invalid. Check the card details and try again.`,
  },
  {
    name: 'INVALID_CARD_TYPE',
    description: `We couldn't process your payment because this card type isn't accepted. Try a different card.`,
  },
  {
    name: 'INVALID_PIN_OR_PW_OR_ID_ERROR',
    description: TRY_AGAIN,
  },
  {
    name: 'LIMIT_EXCEEDED',
    description: INSUFFICIENT_FUNDS_MSG,
  },
  {
    name: 'NEW_ACCOUNT_INFORMATION_AVAILABLE',
    description: `We couldn't process your payment because this card has expired. Try a valid card.`,
  },
  {
    name: 'PROCESSING_AMOUNT_ERROR',
    description: INVALID_AMOUNT_MSG,
  },
  {
    name: 'PROCESSING_GENERAL_DECLINE',
    description: TRY_AGAIN,
  },
  {
    name: 'PROCESSING_TIMEOUT',
    description: CHECK_CARD,
  },
  {
    name: 'REFUND_FAILED',
    description: `We couldn't process your refund. Try again.`,
  },
  {
    name: 'STRONG_CUSTOMER_AUTHENTICATION_REQUIRED',
    description: TRY_AGAIN,
  },
  {
    name: 'THE_ISSUER_IS_UNAVAILABLE_OR_OFFLINE',
    description: TRY_AGAIN,
  },
  {
    name: 'ACCOUNT_CLOSED',
    description: CONTACT_BANK,
  },
  {
    name: 'INVALID_TRANSACTION',
    description: CONTACT_BANK,
  },
  {
    name: 'PICKUP_CARD',
    description: CONTACT_BANK,
  },
  {
    name: 'PROCESSING_TRANSACTION_NOT_AUTHORIZED',
    description: VENDOR_ERROR,
  },
  {
    name: 'RESTRICTED_CARD',
    description: CONTACT_BANK,
  },
  {
    name: 'SYSTEM_TECHNICAL_ERROR',
    description: CONTACT_BANK,
  },
  {
    name: 'THREE_D_SECURE_FAILURE',
    description: VENDOR_ERROR,
  },
  {
    name: 'INCORRECT_SETUP',
    description: VENDOR_ERROR,
  },
  {
    name: 'CARD_LOST_OR_STOLEN',
    description: CONTACT_BANK,
  },
]
